export default [
    {
        id: 1,
        name: 'Hamburger',
        age: 12,
        image:
            'https://cdn.pixabay.com/photo/2021/01/19/08/47/sandwich-5930496_1280.jpg',
    },
    {
        id: 2,
        name: 'Hester Hogan',
        age: 10,
        image:
            'https://cdn.pixabay.com/photo/2017/01/22/19/20/pizza-2000615_1280.jpg',
    },
    {
        id: 3,
        name: 'Chicken',
        age: 14,
        image:
            'https://cdn.pixabay.com/photo/2017/06/28/17/40/chicken-2451482_1280.jpg',
    },
    {
        id: 4,
        name: 'Sushi',
        age: 8,
        image:
            'https://cdn.pixabay.com/photo/2016/11/25/16/08/sushi-1858696_1280.jpg',
    },
    {
        id: 5,
        name: 'Fresh Salad',
        age: 12,
        image:
            'https://cdn.pixabay.com/photo/2015/05/31/13/59/salad-791891_1280.jpg',
    },
];
